// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"354":"f1d68281","366":"6b4e0b64","413":"463015e7","421":"aa872415","837":"374d227f"}[chunkId] + ".css";
};